var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F0F1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 49.2519C27.1382 49.2519 20.748 42.8617 20.748 35C20.748 27.1383 27.1382 20.7481 34.9999 20.7481C42.8617 20.7481 49.2518 27.1383 49.2518 35C49.2518 42.8617 42.8617 49.2519 34.9999 49.2519ZM34.9999 22.7367C28.2386 22.7367 22.7367 28.2386 22.7367 35C22.7367 41.7614 28.2386 47.2633 34.9999 47.2633C41.7613 47.2633 47.2632 41.7614 47.2632 35C47.2632 28.2386 41.7613 22.7367 34.9999 22.7367Z",
    fill: "#0C1523"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 37.3201C34.4566 37.3201 34.0059 36.8693 34.0059 36.3257V29.697C34.0059 29.1534 34.4566 28.7026 35.0002 28.7026C35.5437 28.7026 35.9945 29.1534 35.9945 29.697V36.3257C35.9945 36.8693 35.5437 37.3201 35.0002 37.3201Z",
    fill: "#0C1523"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9996 41.6288C34.8272 41.6288 34.6549 41.589 34.4958 41.5227C34.3367 41.4564 34.1909 41.3636 34.0583 41.2443C33.939 41.1117 33.8462 40.9792 33.7799 40.8068C33.7136 40.6477 33.6738 40.4754 33.6738 40.303C33.6738 40.1307 33.7136 39.9583 33.7799 39.7992C33.8462 39.6401 33.939 39.4943 34.0583 39.3617C34.1909 39.2424 34.3367 39.1496 34.4958 39.0833C34.814 38.9507 35.1852 38.9507 35.5034 39.0833C35.6625 39.1496 35.8083 39.2424 35.9409 39.3617C36.0602 39.4943 36.153 39.6401 36.2193 39.7992C36.2856 39.9583 36.3253 40.1307 36.3253 40.303C36.3253 40.4754 36.2856 40.6477 36.2193 40.8068C36.153 40.9792 36.0602 41.1117 35.9409 41.2443C35.8083 41.3636 35.6625 41.4564 35.5034 41.5227C35.3443 41.589 35.1719 41.6288 34.9996 41.6288Z",
    fill: "#0C1523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.4ff590bbe242fc1cf2261341a659f71b.svg";
export { ForwardRef as ReactComponent };